// extracted by mini-css-extract-plugin
export var currencyInput = "_nu-1";
export var currencySymbol = "_nu-0";